import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

/** Visible mark for a document or thread that has search embeddings. */
export function EmbeddedSearchMark({ className }: { className?: string }) {
  return (
    <span title="Embedded for search" className="inline-flex shrink-0">
      <Sparkles
        className={cn("h-3.5 w-3.5 text-amber-500", className)}
        aria-label="Embedded for search"
      />
    </span>
  );
}
